<template>
  <vetster-collapse
    v-if="posts.length"
    is-open
  >
    <div
      slot="header"
      class="text-xl 2xl:text-2xl font-title font-semibold text-ocean-900"
    >
      {{ $t('blogpost.related-posts') }}
    </div>
    <div
      slot="content"
      class="grid grid-cols-2 gap-6 mt-4"
    >
      <div
        v-for="post in blogPosts"
        :key="post.id"
        v-lazy-container="{ selector: 'img' }"
        class="col-span-2 sm:col-span-1 lg:col-span-2"
      >
        <vetster-post-tile
          :post="post"
          :hide-badges="true"
          :hide-meta="true"
          :lines="3"
        />
      </div>
    </div>
  </vetster-collapse>
</template>

<script>
import VetsterPostTile from '@/brand-components/Content/VetsterPostTile';
import VetsterCollapse from '@/components/VetsterCollapse';
import BlogPost from '@/models/BlogPost';

export default {
  name: 'VetsterRelatedPost',

  components: {
    VetsterCollapse,
    VetsterPostTile,
  },

  props: {
    posts: {
      type: Array,
      required: true,
    },
  },

  computed: {
    blogPosts() {
      return this.posts.map((post) => new BlogPost(post));
    },
  },
};
</script>
